var _path, _path2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgXlsx(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.8999 4.8005C6.8999 4.19299 7.39239 3.7005 7.9999 3.7005H18.9928L25.0999 9.80761V27.2005C25.0999 27.808 24.6074 28.3005 23.9999 28.3005H7.9999C7.39239 28.3005 6.8999 27.808 6.8999 27.2005V4.8005Z",
    fill: "#F4FBFF",
    stroke: "#58D883"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2002 3.20001L25.6002 9.60001H20.8002C19.9165 9.60001 19.2002 8.88367 19.2002 8.00001V3.20001Z",
    fill: "#58D883"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3602_559)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 11,
    width: 5,
    height: 2,
    fill: "#87E3A7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 15,
    width: 5,
    height: 2,
    fill: "#87E3A7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 19,
    width: 5,
    height: 2,
    fill: "#87E3A7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 23,
    width: 5,
    height: 2,
    fill: "#87E3A7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.3335,
    y: 11,
    width: 3,
    height: 2,
    fill: "#58D883"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.3335,
    y: 15,
    width: 3,
    height: 2,
    fill: "#58D883"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.3335,
    y: 19,
    width: 3,
    height: 2,
    fill: "#58D883"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.3335,
    y: 23,
    width: 3,
    height: 2,
    fill: "#58D883"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 11,
    width: 5,
    height: 2,
    fill: "#87E3A7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 15,
    width: 5,
    height: 2,
    fill: "#87E3A7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 19,
    width: 5,
    height: 2,
    fill: "#87E3A7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 23,
    width: 5,
    height: 2,
    fill: "#87E3A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.83488 10.9074L12.1076 9.34986C12.7433 9.24309 13.3333 9.66653 13.3333 10.2295V25.7706C13.3333 26.3255 12.759 26.7469 12.1299 26.6537L2.85718 25.2793C2.3621 25.206 2 24.8329 2 24.3962V11.787C2 11.3578 2.35017 10.9889 2.83488 10.9074Z",
    fill: "#0CB244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3335 22.3333C9.76279 22.2931 9.19812 22.2516 8.63043 22.2058C8.19258 21.1764 7.75775 20.1581 7.31991 19.1467C6.86998 20.1083 6.41855 21.0587 5.9656 21.998C5.42207 21.9537 4.87552 21.9121 4.3335 21.872C5.03405 20.5183 5.74064 19.1412 6.43818 17.7391C5.81613 16.4243 5.19409 15.133 4.58111 13.8639C5.11709 13.8127 5.65307 13.7628 6.19359 13.7115C6.59067 14.6149 6.98926 15.5279 7.39087 16.4548C7.78795 15.4711 8.19107 14.4791 8.58966 13.4802C9.12866 13.4275 9.66616 13.379 10.2052 13.3333C9.55745 14.8643 8.91276 16.3758 8.26203 17.8666C8.94749 19.3338 9.63898 20.8218 10.3335 22.3333Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3602_559"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.6667,
    height: 17.3333,
    fill: "white",
    transform: "translate(1.3335 9.33331)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlsx);
export default __webpack_public_path__ + "static/media/xlsx.4af9cc70ef5f4d65c1bf3f6fb469fe56.svg";
export { ForwardRef as ReactComponent };